import { z } from "zod";

export const operatorMaterialSchema = z.object({
  materialCode: z.string().min(1).max(80), materialName: z.string().max(240), unit: z.string().min(1).max(80),
  quantityPerProductionUnit: z.number().finite().positive().nullable(), requiredQuantity: z.number().finite().nonnegative().nullable(),
  allOpenWorkOrderReservedQuantity: z.number().finite().nonnegative().nullable().optional(),
  dataIssues: z.array(z.string().max(500)),
  warehouses: z.array(z.object({ code: z.string().min(1).max(80), name: z.string().max(240),
    quantity: z.number().finite().nullable(), reservedQuantity: z.number().finite().nullable(), availableQuantity: z.number().finite().nullable(),
  }).strict()).max(3),
}).strict();
export const operatorMaterialContextSchema = z.object({
  runId: z.string().uuid(), productCode: z.string().min(1).max(80), runVersion: z.number().int().positive(),
  recipeVersion: z.string().min(1).nullable(), observedAt: z.string().datetime({ offset: true }), source: z.literal("MICRO_ERP"),
  available: z.boolean(), unavailableReason: z.string().nullable(), productionQuantity: z.number().finite().positive().nullable(),
  productionUnit: z.string().min(1), materials: z.array(operatorMaterialSchema).max(500),
}).strict();
export type OperatorMaterial = z.infer<typeof operatorMaterialSchema>;
export type OperatorMaterialContext = z.infer<typeof operatorMaterialContextSchema>;
